import React from "react";
// import your tick icon from Figma below:
import TickLogo from "../assets/Tick.svg"; // Replace with actual tick image/svg path
import successBg from "../../assets/card/send-tokens-title-bg.svg"; // If your background topbar svg exists

const SuccessPopup = ({ onClose }) => {
  return (
    <div
      className="fixed inset-0 z-50 bg-black/90 flex justify-center items-center p-4"
      onClick={onClose}
    >
      <div className="flex items-center justify-center w-full h-full">
        <div
          className="bg-white rounded-lg shadow-lg max-w-md w-full max-h-[80vh] flex flex-col overflow-hidden"
          onClick={(e) => e.stopPropagation()}
        >
          {/* Top Bar or Decor (can be svg, optional) */}
          <div className="relative flex justify-center items-center">
            {successBg && (
              <img
                src={successBg}
                alt="Success"
                className="w-[180px] sm:w-[220px] h-auto mx-auto"
              />
            )}
            <button
              className="absolute top-2 right-2 md:right-6 text-[#787878] text-lg sm:text-2xl w-[18px] h-[18px] sm:w-[20px] sm:h-[20px] opacity-100 border-0 flex items-center justify-center"
              onClick={onClose}
            >
              ×
            </button>
          </div>

          {/* Content */}
          <div className="p-6 sm:p-8 w-full flex flex-col items-center">
            {/* Tick Logo */}
            <div className="mb-4 sm:mb-6 mt-12 sm:mt-16">
              <img
                src={TickLogo}
                alt="Success"
                className="w-[44px] h-[44px] sm:w-[56px] sm:h-[56px] mx-auto"
              />
            </div>

            {/* Headline */}
            <div className="font-inter font-semibold text-lg sm:text-[25px] text-[#000000]-600 mb-2 text-center">
              Token Transfer Successful
            </div>

            {/* Subtext */}
            <div className="font-inter font-medium text-gray-500 text-sm sm:text-base text-center">
              Thank you!
            </div>
            <div className="font-inter font-medium text-gray-500 text-sm sm:text-base mb-6 text-center">
              Your tokens was successfully transferred.
            </div>

            <button
              onClick={onClose}
              className="w-[70%] sm:w-[50%] px-4 py-2 sm:px-6 sm:py-3 rounded-lg font-inter 
                transition-colors duration-200 bg-[#00C05B] text-white hover:bg-[#00a24b] mb-12 sm:mb-16 text-sm sm:text-base"
            >
              Return to Home
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessPopup;
